import { render } from "./SecuritySettingsUpdate.vue?vue&type=template&id=f4fc9a70"
import script from "./SecuritySettingsUpdate.vue?vue&type=script&lang=js"
export * from "./SecuritySettingsUpdate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__